<template>
  <!-- TKP-182 md.52/81: formun hangi verilere (ve ilgili kişilere) yazacağı — çoklu seçimde bütün adlar listelenir -->
  <div v-if="hasAny" class="border rounded bg-light small px-3 py-2 mt-3 mb-3" data-test="inventory-targets">
    <div v-if="datas.length" data-test="inventory-targets-data">
      <b>{{ $t("inventory.hierarchy.targets-data", { count: datas.length }) }}:</b> {{ datas.join(", ") }}
    </div>
    <div v-if="rows.length" data-test="inventory-targets-datasubject">
      <b>{{ $t("inventory.hierarchy.targets-datasubject", { count: rows.length }) }}:</b> {{ rows.join(", ") }}
    </div>
  </div>
</template>

<script>
export default {
  name: "inventory-targets",
  props: { targets: { type: Object, default: null } },
  computed: {
    datas() {
      return ((this.targets && this.targets.datas) || []).filter(Boolean);
    },
    rows() {
      return ((this.targets && this.targets.rows) || []).filter(Boolean);
    },
    hasAny() {
      return this.datas.length > 0 || this.rows.length > 0;
    },
  },
};
</script>
